// EMİR #77 — Statik yasal sayfa bileşeni (PRE-AUTH; auth/firestore İMPORT ETMEZ).
// /gizlilik-politikasi · /kullanim-kosullari · /cerez-politikasi · /topluluk-kurallari
// · /iletisim → tek bileşen, koyu/açık tema uyumlu, oturumsuz cold-load çalışır.
import React from "react";
import { getLegalDoc, LEGAL_SLUGS } from "./legalContent";
import "./LegalPage.css";
import { IkonKoprusu } from "../../icon-system/runtime/IkonKoprusu";

interface Props { slug?: string }

function goHome() {
  try {
    // SPA'ya dön (kök) — full sayfa. Yeni sekmede açıldıysa sekmeyi kapatmayı dener.
    if (window.history.length > 1) window.history.back();
    else window.location.href = "/";
  } catch { window.location.href = "/"; }
}

const LegalPage: React.FC<Props> = ({ slug }) => {
  const resolved = String(slug || window.location.pathname || "").replace(/^\/+|\/+$/g, "");
  const doc = getLegalDoc(resolved);

  if (!doc) {
    return (
      <div className="legal-page">
        <div className="legal-wrap">
          <p className="legal-notfound">Belge bulunamadı.</p>
          <nav className="legal-links">
            {LEGAL_SLUGS.map((s) => (
              <a key={s} href={`/${s}`} className="legal-link">/{s}</a>
            ))}
          </nav>
        </div>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <header className="legal-topbar">
        <button className="legal-back pressable" onClick={goHome} aria-label="Geri">← Geri</button>
        <span className="legal-brand">MyLASA</span>
      </header>
      <article className="legal-wrap">
        <h1 className="legal-title">{doc.title}</h1>
        {doc.draftNote && (
          <div className="legal-draft" role="note">
            <IkonKoprusu aile="system.warning" eski="⚠️" /> Bu metin bir taslaktır; yürürlüğe girmeden önce gözden geçirilecektir.
          </div>
        )}
        <p className="legal-updated">Yürürlük: {doc.updated}</p>
        {doc.intro && <p className="legal-intro">{doc.intro}</p>}
        {doc.sections.map((sec, i) => (
          <section key={i} className="legal-section">
            <h2 className="legal-h2">{sec.h}</h2>
            {sec.body.map((line, j) => (
              <p key={j} className="legal-body">{line}</p>
            ))}
          </section>
        ))}
        <footer className="legal-footer">
          <nav className="legal-links">
            {LEGAL_SLUGS.filter((s) => s !== doc.slug).map((s) => (
              <a key={s} href={`/${s}`} className="legal-link">{legalLinkLabel(s)}</a>
            ))}
          </nav>
          <p className="legal-copy">© MyLASA</p>
        </footer>
      </article>
    </div>
  );
};

function legalLinkLabel(slug: string): string {
  switch (slug) {
    case "gizlilik-politikasi": return "Gizlilik Politikası";
    case "kullanim-kosullari": return "Kullanım Koşulları";
    case "cerez-politikasi": return "Çerez Politikası";
    case "topluluk-kurallari": return "Topluluk Kuralları";
    case "iletisim": return "İletişim";
    default: return slug;
  }
}

export default LegalPage;
